import { getCurrentInstance } from 'vue';
import type { SSRContext } from '@model/ssr/context';

export function useSsrEngineContext() {
    const instance = getCurrentInstance();
    if (!instance) return null;

    const ssrContext =
        instance.appContext.config.globalProperties
            .$ssrContext as SSRContext | undefined;

    if (!ssrContext) return null;

    function pushHead(entry: any) {
        ssrContext.res.meta.head.push(entry);
    }

    function addSvgSymbol(symbol: string) {
        ssrContext.res.svgSymbols.add(symbol);
    }

    return {
        ssrContext,
        res: ssrContext.res,
        req: ssrContext.req,
        public: ssrContext.public,

        pushHead,
        addSvgSymbol,
    };
}
